import { render, staticRenderFns } from "./languageBar.vue?vue&type=template&id=2d2e6a0c&scoped=true"
import script from "./languageBar.vue?vue&type=script&lang=js"
export * from "./languageBar.vue?vue&type=script&lang=js"
import style0 from "./languageBar.vue?vue&type=style&index=0&id=2d2e6a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e6a0c",
  null
  
)

export default component.exports